import { useTranslation } from '@shared/i18n';
import { useTelegramStatus } from '@features/settings/hooks/useTelegram';
import { TelegramStatusBadge } from '@features/settings/components/TelegramStatusBadge';
import { useStoreDashboard } from '../hooks/useStoreDashboard';

function formatCurrency(value: number, currency: string): string {
  return new Intl.NumberFormat('ru-RU', { style: 'currency', currency }).format(value);
}

export function StoreStatusCard() {
  const { t } = useTranslation();
  const { data: telegramStatus } = useTelegramStatus();
  const { data, isLoading } = useStoreDashboard();

  if (!telegramStatus?.linked) return null;
  if (isLoading) {
    return (
      <div className="card p-6">
        <p className="text-sm text-gray-500">{t('common.loading')}</p>
      </div>
    );
  }
  if (!data) return null;

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900">{t('store_status.title')}</h3>
        <TelegramStatusBadge linked />
      </div>

      <div className="grid grid-cols-3 gap-4 text-center">
        <div>
          <div className="text-2xl font-bold text-gray-900">{data.orderCount}</div>
          <div className="text-xs text-gray-500 mt-1">{t('store_status.orders')}</div>
        </div>
        <div>
          <div className="text-2xl font-bold text-gray-900">
            {formatCurrency(data.revenue, data.currency)}
          </div>
          <div className="text-xs text-gray-500 mt-1">{t('store_status.revenue')}</div>
        </div>
        <div>
          <div className="text-2xl font-bold text-gray-900">
            {formatCurrency(data.avgOrderValue, data.currency)}
          </div>
          <div className="text-xs text-gray-500 mt-1">{t('store_status.avg_order')}</div>
        </div>
      </div>

      <p className="text-xs text-gray-400 mt-4">{t('store_status.details_in_telegram')}</p>
    </div>
  );
}
